export default __webpack_public_path__ + "static/media/tecnocasa.2d9814df.png";